import { CobaltLogo } from '@cae/cobalt-react/components/logo';
import { MediaQuery } from '@cae/cobalt-react/enums';
import { useMediaQuery } from '@cae/cobalt-react/hooks';
import * as React from 'react';

import styles from './RegisterUserBrandingPanel.module.css';

const RegisterUserBrandingPanel = React.memo((): React.ReactElement => {
  const isMobile = useMediaQuery(MediaQuery.Mobile);

  return (
    <div
      className={styles.brandingPanel}
      data-testid="register-user-branding-panel"
    >
      <CobaltLogo
        color="white"
        size={isMobile ? 'medium' : 'x-large'}
        className={styles.brandingLogo}
      />
      <span className={styles.brandingTitle}>Create a new CAE account</span>
      <span className={styles.brandingSubtitle}>
        Enhance your experience with CAE.
      </span>
    </div>
  );
});

RegisterUserBrandingPanel.displayName = 'RegisterUserBrandingPanel';
export { RegisterUserBrandingPanel };
